import { ID } from '@datorama/akita';
import { Column, Entity } from '../entity';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

export interface ICPMSOutlet extends IEntity {
  outletId: number;
  outletDescription: string;
  organizationTradeName: string;
  orgId: number;
}

@Entity({
  name: PageTitles.cpmsOutlet,
  language: LanguagePage.cpmsOutlet,
})
export class CPMSOutlet implements ICPMSOutlet {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  outletDescription: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  organizationTradeName: string;

  id: ID;
  outletId: number;
  orgId: number;

  constructor(outlet: ICPMSOutlet) {
    this.id = outlet.id;
    this.outletId = outlet.outletId;
    this.outletDescription = outlet.outletDescription;
    this.organizationTradeName = outlet.organizationTradeName;
    this.orgId = outlet.orgId;
  }
}
